define("OrderHistory.Details.View.Extension", [
  "OrderHistory.Details.View",
  "underscore",
  "jQuery",
  "Item.Model",
  "Ames.RentFromAnywhere.RentFromAnywhere.SS2Model",
  "LiveOrder.Model",
], function (
  OrderHistoryDetailsView,
  _,
  jQuery,
  ItemModel,
  RentFromAnywhereSS2Model,
  LiveOrderModel
) {
  "use strict";
  _.extend(OrderHistoryDetailsView.prototype, {
    initialize: _.wrap(
      OrderHistoryDetailsView.prototype.initialize,
      function (fn, options) {
        var self = this;
        fn.apply(this, _.toArray(arguments).slice(1));
        this.sameFulfillmentRecord = false;
        this.enableLabelCreation = false;
        this.isRentalExpired = false;
        this.hasOpenRma = false;
        this.fulfillmentIdForLabelCreation = null;
        self.orderStatusText = null;

        // One service call per order, shared with the line views (see
        // RentFromAnywhereSS2Model.orderInfo). Resolves null for non-rental orders.
        this.rentModel = new RentFromAnywhereSS2Model();
        RentFromAnywhereSS2Model.orderInfo(this.id)
          .done(function (resp) {
            if (!resp || resp.orderStatus == null) {
              return;
            }
            var date = new Date(resp.rental_end_date);
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            date.setHours(0, 0, 0, 0);

            var month = (date.getMonth() + 1).toString().padStart(2, "0");
            var day = date.getDate().toString().padStart(2, "0");
            var year = date.getFullYear();

            self.rentalEndDate = month + "/" + day + "/" + year;
            self.status = resp.orderStatus;
            self.sameFulfillmentRecord = resp.sameFulfillmentRecord;
            self.isRentalExpired = date < today && self.status !== "4";
            // self.isRentalExpired = true; // For testing purposes, set to true to show the message and label creation option
            self.hasOpenRma = resp.hasOpenRma;
            self.fulfillmentIdForLabelCreation = resp.fulfillRecordId;
            self.enableLabelCreation =
              !!self.sameFulfillmentRecord &&
              !!self.isRentalExpired &&
              !self.hasOpenRma &&
              !!self.fulfillmentIdForLabelCreation;
            
            self.orderStatusText = resp.orderStatusText || null;
            
            if (self.orderStatusText) {
              setTimeout(function () {
                $('.order-history-packages-shipped-status-value').text(self.orderStatusText);
              }, 1500);
            }

              self.render()
          });
      }
    ),
    events: {
      'click [data-action="add-to-cart"]': "addToCart",
      'click [data-action="go-to-returns"] a': "goToReturns",
      'click [data-action="create-return-label"]': "createReturnLabel",
    },
    createReturnLabel: function (e) {
      e.preventDefault();
      e.stopPropagation();

      var self = this;
      var orderNumber = this.model.get("tranid") || "N/A";

      var todaysDate = new Date();
      // format todays date as MM/DD/YYYY
      var month = (todaysDate.getMonth() + 1).toString().padStart(2, "0");
      var day = todaysDate.getDate().toString().padStart(2, "0");
      var year = todaysDate.getFullYear();
      var formattedDate = month + "/" + day + "/" + year;

      var fulfillmentId = this.fulfillmentIdForLabelCreation;

      if (!fulfillmentId) {
        return;
      }

      // Build and inject popup
      var $overlay = jQuery('<div class="return-label-overlay"></div>');
      var $popup = jQuery(
        '<div class="return-label-popup">' +
          '<div class="return-label-popup-header">' +
          "<span>Create Return Label</span>" +
          '<button class="return-label-popup-close" data-action="close-popup">&times;</button>' +
          "</div>" +
          '<div class="return-label-popup-body">' +
          "<p>Create a return shipping label for <strong>" +
          _.escape(orderNumber) +
          "</strong>?</p>" +
          '<div class="return-label-popup-detail">' +
          "<span>Due Date: <strong>" +
          _.escape(formattedDate || "N/A") +
          "</strong></span>" +
          "</div>" +
          "</div>" +
          '<div class="return-label-popup-footer">' +
          '<button class="return-label-popup-btn return-label-popup-btn-no" data-action="close-popup">No</button>' +
          '<button class="return-label-popup-btn return-label-popup-btn-yes">Yes, Create Label</button>' +
          "</div>" +
          "</div>"
      );

      jQuery("body").append($overlay).append($popup);

      function closePopup() {
        $overlay.remove();
        $popup.remove();
      }

      // Close on overlay click or close/no buttons
      $overlay.on("click", closePopup);
      $popup.on("click", '[data-action="close-popup"]', closePopup);

      // Yes - handle the request
      $popup.find(".return-label-popup-btn-yes").on("click", function () {
        var $btn = jQuery(this);
        $btn.prop("disabled", true).text("Creating...");
        $popup.find(".return-label-popup-btn-no").prop("disabled", true);
        $popup.find(".return-label-popup-close").prop("disabled", true);

        var suiteletUrl =
          "/app/site/hosting/scriptlet.nl" +
          "?script=customscript_rental_return_label_sl" +
          "&deploy=customdeploy_rental_return_label_sl" +
          "&rentalFulfillmentId=" +
          encodeURIComponent(fulfillmentId) +
          "&createdFromWeb=true"

        jQuery
          .ajax({
            url: suiteletUrl,
            type: "GET",
            dataType: "json",
          })
          .done(function (response) {
            closePopup();
            if (response && response.success) {
              // Open label PDF(s) for download
              if (response.labels && response.labels.length > 0) {
                for (var i = 0; i < response.labels.length; i++) {
                  if (response.labels[i].fileUrl) {
                    window.open(
                      "https://shopamestools.com" +
                        response.labels[i].fileUrl,
                      "_blank"
                    );
                  }
                }
              }
              self._showResultPopup(
                "success",
                "Return Label Created",
                response.message || "Label created successfully."
              );
            } else {
              self._showResultPopup(
                "error",
                "Label Creation Failed",
                response && response.message
                  ? response.message
                  : "An unknown error occurred."
              );
            }
          })
          .fail(function (jqXHR, textStatus, errorThrown) {
            closePopup();
            self._showResultPopup(
              "error",
              "Request Failed",
              "Could not reach the server. Please try again. (" +
                textStatus +
                ")"
            );
          });
      });
    },
    _showResultPopup: function (type, title, message) {
      var isSuccess = type === "success";
      var headerClass = isSuccess
        ? "return-label-result-header-success"
        : "return-label-result-header-error";
      var icon = isSuccess ? "&#10003;" : "&#10007;";

      var $overlay = jQuery('<div class="return-label-overlay"></div>');
      var $popup = jQuery(
        '<div class="return-label-popup">' +
          '<div class="return-label-popup-header ' +
          headerClass +
          '">' +
          "<span>" +
          icon +
          " " +
          _.escape(title) +
          "</span>" +
          '<button class="return-label-popup-close" data-action="close-result">&times;</button>' +
          "</div>" +
          '<div class="return-label-popup-body">' +
          "<p>" +
          message +
          "</p>" +
          "</div>" +
          '<div class="return-label-popup-footer">' +
          '<button class="return-label-popup-btn return-label-popup-btn-yes" data-action="close-result">OK</button>' +
          "</div>" +
          "</div>"
      );

      jQuery("body").append($overlay).append($popup);

      function closeResult() {
        $overlay.remove();
        $popup.remove();
        if (isSuccess) {
          window.location.reload();
        }
      }

      $overlay.on("click", closeResult);
      $popup.on("click", '[data-action="close-result"]', closeResult);
    },
    getContext: _.wrap(
      OrderHistoryDetailsView.prototype.getContext,
      function (fn) {
        var originalRet = fn.apply(this, _.toArray(arguments).slice(1));
        return _.extend(originalRet, {
          sameFulfillmentRecord: this.sameFulfillmentRecord,
          enableLabelCreation: this.enableLabelCreation,
          isRentalExpired: this.isRentalExpired,
          hasOpenRma: this.hasOpenRma,
          fulfillmentIdForLabelCreation: this.fulfillmentIdForLabelCreation,
          orderStatusText: this.orderStatusText,
        });
      }
    ),
  });
});
